// extracted by mini-css-extract-plugin
export default {"virtual":"Virtual_virtual__wTQRA","left":"Virtual_left__tw2in","wrapper":"Virtual_wrapper__+ea6u"};